import axios from 'axios';
import { useState } from 'react';


const useNCM = (getApi)=> {
    const consultaPorcentagemAprxImpostos = async (produto, ncm) => {
        const api = await getApi();

        let ncms = sessionStorage.getItem("ncms");
        let ncmsArr = {};
        if(!ncms){
            ncms = JSON.stringify(ncmsArr);
            sessionStorage.setItem("ncms",ncms);
        } else {
            ncmsArr = JSON.parse(ncms);
        }
        
        if( ncm in ncmsArr){
            return ncmsArr[ncm];
        }
        
        const {data:empresa} = await api.get("empresa");
        let ibptToken = 'u-vu4b6bqyStVNOr3CMpQ3XyjIpInJgROu5Erl0SPYIDW_gBFLX36THi29zU23YA';

        const url = "https://ibpt.emitirnotas.com.br/produtos";
        const gtin = 'SEM GTIN';
        const descricao = 'DESCRICAO';
        const valor = 10;
        const uf = "SP"
        let unidadeMedida = produto.uCom;
        let cnpj = '13176362000180';
 
        if(empresa.ibptToken){
            ibptToken = empresa.ibptToken;
            cnpj = empresa.cnpj
        }
        
        const ax = axios.create();
        const result = await ax.get(url, {
            params: {uf, codigo:ncm, ex: "0",  gtin, descricao, valor, unidadeMedida, cnpj, token:ibptToken}
        })

        const {data:retornoIBPT} = result;
        const {Estadual, Municipal, Nacional} = retornoIBPT;
        const porcentagemAproximadaImpostos =Estadual + Municipal + Nacional;


        ncmsArr[ncm] = porcentagemAproximadaImpostos;
        sessionStorage.setItem("ncms", JSON.stringify(ncmsArr));
        
        return porcentagemAproximadaImpostos;
    }

    return {consultaPorcentagemAprxImpostos};
}

const useComposicao = (getApi)=>{
    const [dataStore, setDataStore] = useState([]);

    const onSearch = async (query, dataStore)=>{
        try{

            const api = await getApi();
     
            const {data:sugestoes} = await api.get("/produtos/v3/sugestoes?tipoProduto=SIMPLES,MATERIA_PRIMA");
    
            setDataStore(sugestoes);
        } catch(err){
            console.log(err);
        }
       
    } 

    const onFilter = (termo)=> {
        if(dataStore && dataStore.length){

            const sugestoesFiltradas = dataStore.filter((sugestao) => {
                return sugestao.descricao.toLowerCase().indexOf(termo.toLowerCase()) >= 0;
            });
    
            return sugestoesFiltradas.map(sugestao => {
                const {descricao:label} = sugestao;
                return {label, value: label};
            });
        }
        return null;

    }

    return {onSearch, onFilter, dataStore}
}

const useProduto = (getApi, form, Barcoder) => {

    const aplicaValidacao = (produto, isSubmiting=false)=>{
        const validationStatuses = produto.validate(Barcoder.validate);
        
        const retorno = {
            isValid: true,
            hasErrors: false,
            errorsStatus: validationStatuses
        };
 
        for(const status of validationStatuses){
            if(form.isFieldTouched(status.name) || isSubmiting){
                form.setFields([status]);
                if(status.errors.length){
                    retorno.isValid = false;
                    retorno.hasErrors = true;
                    retorno.firstErrorField = status.name;
                }
            }
        }

        return retorno;
    }

    const salvaProduto = async (produto) => {
        const {isValid, firstErrorField, errorsStatus} = aplicaValidacao(produto, true);
        // const isValid = produtoCompleto.validate(form.setFields, Barcoder.validate);
        const retorno = {
            sucesso: true
        }

        if(isValid){
            const apiData = produto.toApiJson();
            const api = await getApi();
            try{
                console.log("Enviando dados produto",apiData);
                const {data} = await api.post("/produtos/v3", apiData);
                retorno.data = data;
            } catch(err){
                const {data} = err;
                retorno.sucesso = false;
                retorno.tipoErro = "API_ERROR"
                if(data){
                    retorno.tipoErro = "API_VALIDATION"
                    retorno.data = data    
                } else {
                    retorno.data = err
                }
            }
        } else{
            retorno.sucesso = false;
            retorno.tipoErro = "FORM_VALIDATION";
            retorno.data = {isValid, firstErrorField, errorsStatus};
        }

        return retorno
    }

    const buscarProdutos = async (filtro) => {
        const {termo, page=1, pageSize:limit, sort} = filtro;
        const {field, order} = sort;

        const offset = (page - 1) * limit;
        
        const api = await getApi();
        const {data} = await api.get("/produtos/v3", {
            params: {termo, limit, offset, sort: field, order }
        });

        return data;
    }

    const buscarProdutoPorUUID = async (uuid) => {
        // const {termo, page=1, pageSize:limit} = filtro;

        // const offset = (page - 1) * limit;
      
        const api = await getApi();
        const {data} = await api.get(`/produtos/v3/${uuid}`);

        return data;
    }


    const removeProdutos = async(uuidList) => {
        const api = await getApi();
        const {data} = await api.delete(`/produtos/v3/`, {
            data: uuidList
        });

        return data;
    }
    

   


    return {salvaProduto, aplicaValidacao,buscarProdutos, buscarProdutoPorUUID, removeProdutos};
}

export {useProduto, useNCM, useComposicao}